<div class="layout-wrapper" [ngClass]="containerClass">
  <sm-layout-topbar></sm-layout-topbar>
  <div class="layout-main-container flex-1">
    <sm-layout-sidebar></sm-layout-sidebar>
    <div class="layout-main overflow-auto flex-1">
      <div class="max-w-[2160px] mx-auto px-6 flex-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <sm-layout-footer></sm-layout-footer>
  <div class="layout-mask animate-fadein"></div>
  <p-toast [position]="'bottom-right'" [life]="8000"></p-toast>
</div>